export const commonShadow = '0px 8px 10px -5px rgba(0,0,0,0.1), 0px 16px 24px 2px rgba(0,0,0,0.05), 0px 6px 30px 5px rgba(0,0,0,0.05)';
